import { render, staticRenderFns } from "./movimientos.vue?vue&type=template&id=1fa88cde&scoped=true"
import script from "./movimientos.vue?vue&type=script&lang=js"
export * from "./movimientos.vue?vue&type=script&lang=js"
import style0 from "./movimientos.vue?vue&type=style&index=0&id=1fa88cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa88cde",
  null
  
)

export default component.exports